import { Injectable } from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {QuizModalComponent} from "../quiz/quiz-modal/quiz-modal.component";

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  constructor(private dialog: MatDialog) {}

  openQuizGenerationDialog() {
    const dialogRef = this.dialog.open(QuizModalComponent);
    dialogRef.afterClosed().subscribe();
  }
}
